import { Card } from '@app/app/_components/Card/Card';
import { GhostButton } from '@app/app/_components/GhostButton/GhostButton';
import { Heading } from '@app/app/_components/Heading/Heading';
import { PlusIcon } from '@app/app/_icons/PlusIcon';
import { useTranslations } from 'next-intl';

interface Props {
    onAddBeneficiary: () => void;
}

export function AddBeneficiaryButton({ onAddBeneficiary }: Props) {
    const t = useTranslations();

    return (
        <GhostButton onClick={onAddBeneficiary}>
            <Card className="flex w-full flex-row items-center justify-center p-6 text-primary-500 hover:bg-primary-100">
                <Heading level="h3" className="text-lg text-primary-500">
                    {t('lifeInsurance.addBeneficiaries')}
                </Heading>
                <PlusIcon className="ml-1 inline size-6" />
            </Card>
        </GhostButton>
    );
}
